
<template>
    <Feature>
        
        <template slot="convert_to_text_title">{{$lang.speaker.convert_to_text_title}}</template>
        <template slot="convert_to_text_desc">{{$lang.speaker.convert_to_text_desc}}</template>
        <template slot="start_your_trial">{{$lang.speaker.start_your_trial}}</template>
        <template slot="hero_image">
            <img alt="convert to text banner" :src="hero" width="500">
        </template>
        <template slot="three_step_title">{{$lang.speaker.three_step_title}}</template>
        <template slot="step_one">{{$lang.speaker.step_one}}</template>

        <!-- 3 step banner -->
        <template slot="step_one_image">
            <img alt="upload file step image" :src="stepOneImage">
        </template>
        <template slot="step_one_desc">{{$lang.speaker.step_one_desc}}</template>

        <template slot="step_two">{{$lang.speaker.step_two}}</template>
        <template slot="step_two_image">
            <img alt="transcribe method step image" :src="stepTwoImage">
        </template>
        <template slot="step_two_desc">{{$lang.speaker.step_two_desc}}</template>

        <template slot="step_three">{{$lang.speaker.step_three}}</template>
        <template slot="step_three_image">
            <img alt="export step image" :src="stepThreeImage">
        </template>
        <template slot="step_three_desc">{{$lang.speaker.step_three_desc}}</template>

        <!-- Tutorial-->
        <template slot="feature_tutorial_title">{{$lang.speaker.feature_tutorial_title}}</template>
        <template slot="feature_tutorial_desc"><p v-html="$lang.speaker.feature_tutorial_desc">{{$lang.speaker.feature_tutorial_desc}}</p></template>
        <template slot="feature_tutorial_media">
            <div class="play-button" @click="onTutorialClicked" v-show="isHidden">
                  <a class="popup-vimeo animated-circle"><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
           
                </div>
                  <img v-if="isHidden" alt="feature tutorial" :src="tutorialPoster" @click="onTutorialClicked">
            <iframe v-if="!isHidden" width="560" height="315" :src="$lang.speaker.feature_tutorial_youtube" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </template>

        <!-- Extra info-->
        <template slot="feature_extra_title">{{$lang.speaker.feature_extra_title}}</template>
        <template slot="feature_extra_desc">
            <p style="text-align: left;" v-html="$lang.speaker.feature_extra_desc">
                </p>
        </template>
        
    </Feature>
</template>

<script>
import Feature from "./Feature";
const images = require.context('../assets/images/features', true, /\.webp$/)

export default {
  name: "SpeakerPage",
  data: () => ({
    heroImage: null,
    stepOneImage:'',
    stepTwoImage:'',
    stepThreeImage:'',
    tutorialPoster:'',
    hero:'',
    isHidden:true
  }),
  metaInfo() {
    const me = this;
    return{
      title: me.$lang.speaker.convert_to_text_title,//me.$lang.about.taption,
      titleTemplate: '%s - Taption',
      meta: [
        { vmid: 'name', content: me.$lang.speaker.convert_to_text_title, itemprop: 'name' },
        { vmid: 'description', content: me.$lang.speaker.convert_to_text_desc, itemprop: 'description' },
        { vmid: 'article_desc', content: me.$lang.speaker.convert_to_text_desc, name: 'description' },
        { vmid: 'og_title', content: me.$lang.speaker.convert_to_text_title, property: 'og:title' },
        { vmid: 'og_desc', content: me.$lang.speaker.convert_to_text_desc, property: 'og:description' },
        { vmid:'twitter_title', content: me.$lang.speaker.convert_to_text_title, name: 'twitter:title' },
        { vmid:'twitter_desc',content: me.$lang.speaker.convert_to_text_desc, name: 'twitter:description' },
      ]
    }
  },
  components: {
    Feature
  },
  methods: {
    onTutorialClicked(){
        this.isHidden = false;
    }
  },
  mounted(){
    const me = this;
    me.stepOneImage = images(me.$lang.speaker.step_one_img)
    me.stepTwoImage = images(me.$lang.speaker.step_two_img)
    me.stepThreeImage = images(me.$lang.speaker.step_three_img)
    me.tutorialPoster = images(me.$lang.speaker.feature_tutorial_poster_url)
    me.hero = images(me.$lang.speaker.hero_img)
  }
}

</script>


           